import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/ummcolumn/hearderLayout/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/ummcolumn/hearderLayout/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/ummcolumn/hearderLayout/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/ummcolumn/hearderLayout/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/ummcolumn/hearderLayout/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/ummcolumn/hearderLayout/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/ummcolumn/hearderLayout/import',
      method: 'post',
      data: data
    })
  }
}
